import {customType} from 'drizzle-orm/pg-core';
import type {ScreenPositions} from '@/app/db/screenPositions';
import {screenPositions} from '@/app/db/screenPositions';

export const pgScreenPositionsColumn = customType<{
  data: ScreenPositions;
  driverData: unknown;
}>({
  dataType() {
    return 'jsonb';
  },
  toDriver(value: ScreenPositions) {
    return JSON.stringify(value);
  },
  fromDriver(value) {
    const parsed = screenPositions.safeParse(value);

    if (parsed.error) {
      console.error('invalid data in pgScreenPositions', value, parsed.error);
      throw parsed.error;
    }

    return parsed.data;
  },
});
